module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements#ack"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#chapter1"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("1")]), _vm._v(" Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#chapter2"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("2")]), _vm._v(" History")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#chapter3"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("3")]), _vm._v(" Biographies and Sources")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#chapter4"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("4")]), _vm._v(" Hull Design")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05#chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("5")]), _vm._v(" Hull Construction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter06#chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("6")]), _vm._v(" Pumps")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter07#chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("7")]), _vm._v(" Steering")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter08#chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("8")]), _vm._v(" Ground Tackle")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter09#chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("9")]), _vm._v(" Deck Arrangements and Accommodation")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("10")]), _vm._v(" Decoration")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter10#color",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Colour section")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter11#chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("11")]), _vm._v(" Masts and Yards")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter12#chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("12")]), _vm._v(" Sails")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter13#chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("13")]), _vm._v(" Rigging")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter14#chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("14")]), _vm._v(" Ordnance")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter15#chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocj"
  }, [_vm._v("15")]), _vm._v(" Boats")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#plates",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plates")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Appendix01#app1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocs"
  }, [_vm._v("Appendix I")]), _vm._v(" Trinity House Protest")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Appendix02#app2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocs"
  }, [_vm._v("Appendix II")]), _vm._v(" Sail Carrying Capacity")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocat"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c59a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0